import { render, staticRenderFns } from "./AppMenuButton.vue?vue&type=template&id=37f6f102&scoped=true&"
import script from "./AppMenuButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppMenuButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f6f102",
  null
  
)

export default component.exports